import React, { forwardRef, useImperativeHandle, useState, useCallback, useEffect } from 'react';
import { Popover, TextField, DatePicker, Icon, Button, Select, FormLayout, LegacyStack } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';
import { getNewDate, formatDate } from './../Utils';

export const DateRangeCustom = forwardRef((props, ref) => {

    const isValidDate = function (dateString) {
        var isValid = dateString.match(/^\d{4}-\d{2}-\d{2}$/) != null;
        if (isValid) {
            var d = new Date(dateString);
            isValid = d instanceof Date && !isNaN(d);
        }

        return isValid;
    }

    const getTitle = function (startDate, endDate) {
        var startMonthDay = startDate.toLocaleString('default', { month: 'short', day: "numeric" });
        var endMonthDay = endDate.toLocaleString('default', { month: 'short', day: "numeric" });
        var startYear = startDate.getFullYear();
        var endYear = endDate.getFullYear();

        if (startYear === endYear) {
            if (startMonthDay === endMonthDay) {
                return startMonthDay + ', ' + endYear;
            }
            else {
                return startMonthDay + '-' + endMonthDay + ', ' + endYear;
            }
        }
        else {
            return startMonthDay + ', ' + startYear + '-' + endMonthDay + ', ' + endYear;
        }
    }

    const getQuarterRangeByYear = function (quarter, year) {
        var quarterRange = {};

        switch (quarter) {
            case 1:
                quarterRange = { start: `${year}-01-01`, end: `${year}-03-31` }
                break;
            case 2:
                quarterRange = { start: `${year}-04-01`, end: `${year}-06-30` }
                break;
            case 3:
                quarterRange = { start: `${year}-07-01`, end: `${year}-09-30` }
                break;
            case 4:
                quarterRange = { start: `${year}-10-01`, end: `${year}-12-31` }
                break;
            default:
                break;
        }

        return quarterRange;
    }

    const getQuarterRange = function (forDate) {
        var year = forDate.getFullYear();
        var quarter = Math.floor((forDate.getMonth() + 3) / 3);
        return getQuarterRangeByYear(quarter, year);
    }

    const getDatesByRange = function (range) {
        var startDateJs = null;
        var endDateJs = null;

        var todayJs = getNewDate();

        var todayDay = todayJs.getDay();
        var todayMonth = todayJs.getMonth();
        var todayYear = todayJs.getFullYear();

        var prevYear = todayYear - 1;

        var yesterdayJs = getNewDate();
        yesterdayJs.setDate(yesterdayJs.getDate() - 1);

        var tomorrowJs = getNewDate();
        tomorrowJs.setDate(tomorrowJs.getDate() + 1);

        if (range === 'allTime') {
            startDateJs = getNewDate(`2020-01-01`);;
            endDateJs = tomorrowJs;
        }
        else if (range === 'today') {
            startDateJs = todayJs;
            endDateJs = todayJs;
        }
        else if (range === 'yesterday') {
            startDateJs = yesterdayJs;
            endDateJs = yesterdayJs;
        }
        else if (range === 'last24Hours') {
            var last24HoursJs = new Date();
            last24HoursJs.setHours(last24HoursJs.getHours() - 24);

            startDateJs = last24HoursJs;
            endDateJs = new Date();
        }
        else if (range === 'last7Days') {
            var last7DaysJs = getNewDate(todayJs);
            last7DaysJs.setDate(last7DaysJs.getDate() - 7);

            startDateJs = last7DaysJs;
            endDateJs = todayJs;
        }
        else if (range === 'last30Days') {
            var last30DaysJs = getNewDate(todayJs);
            last30DaysJs.setDate(last30DaysJs.getDate() - 30);

            startDateJs = last30DaysJs;
            endDateJs = todayJs;
        }
        else if (range === 'last90Days') {
            var last90DaysJs = getNewDate(todayJs);
            last90DaysJs.setDate(last90DaysJs.getDate() - 90);

            startDateJs = last90DaysJs;
            endDateJs = todayJs;
        }
        else if (range === 'lastMonth') {
            startDateJs = new Date(todayYear, todayMonth - 1, 1);
            endDateJs = new Date(startDateJs.getFullYear(), startDateJs.getMonth() + 1, 0);
        }
        else if (range === 'lastYear') {
            startDateJs = getNewDate(`${prevYear}-01-01`);
            endDateJs = getNewDate(`${prevYear}-12-31`);
        }
        else if (range === 'weekToDate') {
            var weekToDateJs = getNewDate(todayJs);
            var diff = weekToDateJs.getDate() - todayDay + (todayDay === 0 ? -6 : 1);
            weekToDateJs.setDate(diff);

            startDateJs = weekToDateJs;
            endDateJs = todayJs;
        }
        else if (range === 'monthToDate') {
            startDateJs = new Date(todayYear, todayMonth, 1);
            endDateJs = todayJs;
        }
        else if (range === 'quarterToDate') {
            var todayQuarterRange = getQuarterRange(todayJs);

            startDateJs = getNewDate(todayQuarterRange.start);
            endDateJs = todayJs;
        }
        else if (range === 'yearToDate') {
            startDateJs = getNewDate(`${todayYear}-01-01`);
            endDateJs = todayJs;
        }
        else if (range === 'prevYear4Quarter') {
            var lastYear4QuarterRange = getQuarterRangeByYear(4, prevYear);

            startDateJs = getNewDate(lastYear4QuarterRange.start);
            endDateJs = getNewDate(lastYear4QuarterRange.end);
        }
        else if (range === 'prevYear3Quarter') {
            var lastYear3QuarterRange = getQuarterRangeByYear(3, prevYear);

            startDateJs = getNewDate(lastYear3QuarterRange.start);
            endDateJs = getNewDate(lastYear3QuarterRange.end);
        }
        else if (range === 'prevYear2Quarter') {
            var lastYear2QuarterRange = getQuarterRangeByYear(2, prevYear);

            startDateJs = getNewDate(lastYear2QuarterRange.start);
            endDateJs = getNewDate(lastYear2QuarterRange.end);
        }
        else if (range === 'prevYear1Quarter') {
            var lastYear1QuarterRange = getQuarterRangeByYear(1, prevYear);

            startDateJs = getNewDate(lastYear1QuarterRange.start);
            endDateJs = getNewDate(lastYear1QuarterRange.end);
        }

        if (startDateJs !== null && endDateJs != null) {
            return { start: startDateJs, end: endDateJs }
        }
        else {
            return null;
        }
    }

    const getRange = function (startDate, endDate) {
        var todayJs = getNewDate();
        var today = formatDate(todayJs);

        var todayDay = todayJs.getDay();
        var todayMonth = todayJs.getMonth();
        var todayYear = todayJs.getFullYear();

        if (startDate === null && endDate === null) {
            return 'allTime';
        }

        if (startDate === endDate && startDate === today) {
            return 'today';
        }

        var yesterdayJs = getNewDate();
        yesterdayJs.setDate(yesterdayJs.getDate() - 1);
        var yesterday = formatDate(yesterdayJs);

        if (startDate === endDate && startDate === yesterday) {
            return 'yesterday';
        }

        var last7DaysJs = getNewDate(todayJs);
        last7DaysJs.setDate(last7DaysJs.getDate() - 7);
        var last7Days = formatDate(last7DaysJs);

        if (startDate === last7Days && endDate === today) {
            return 'last7Days';
        }

        var last30DaysJs = getNewDate(todayJs);
        last30DaysJs.setDate(last30DaysJs.getDate() - 30);
        var last30Days = formatDate(last30DaysJs);

        if (startDate === last30Days && endDate === today) {
            return 'last30Days';
        }

        var last90DaysJs = getNewDate(todayJs);
        last90DaysJs.setDate(last90DaysJs.getDate() - 90);
        var last90Days = formatDate(last90DaysJs);

        if (startDate === last90Days && endDate === today) {
            return 'last90Days';
        }

        var lastMonthFirstDateJs = new Date(todayYear, todayMonth - 1, 1);
        var lastMonthLastDateJs = new Date(lastMonthFirstDateJs.getFullYear(), lastMonthFirstDateJs.getMonth() + 1, 0);
        var lastMonthFirstDate = formatDate(lastMonthFirstDateJs);
        var lastMonthLastDate = formatDate(lastMonthLastDateJs);

        if (startDate === lastMonthFirstDate && endDate === lastMonthLastDate) {
            return 'lastMonth';
        }

        var prevYear = todayYear - 1;

        if (startDate === `${prevYear}-01-01` && endDate === `${prevYear}-12-31`) {
            return 'lastYear';
        }

        var weekToDateJs = getNewDate(todayJs);
        var diff = weekToDateJs.getDate() - todayDay + (todayDay === 0 ? -6 : 1);
        weekToDateJs.setDate(diff);
        var weekToDate = formatDate(weekToDateJs);

        if (startDate === weekToDate && endDate === today) {
            return 'weekToDate';
        }

        var thisMonthFirstDateJs = new Date(todayYear, todayMonth, 1);
        var thisMonthFirstDate = formatDate(thisMonthFirstDateJs);

        if (startDate === thisMonthFirstDate && endDate === today) {
            return 'monthToDate';
        }

        var todayQuarterRange = getQuarterRange(todayJs);

        if (startDate === todayQuarterRange.start && endDate === today) {
            return 'quarterToDate';
        }

        var thisYearFirstDate = `${todayYear}-01-01`;

        if (startDate === thisYearFirstDate && endDate === today) {
            return 'yearToDate';
        }

        var lastYear4QuarterRange = getQuarterRangeByYear(4, prevYear);

        if (startDate === lastYear4QuarterRange.start && endDate === lastYear4QuarterRange.end) {
            return 'prevYear4Quarter';
        }

        var lastYear3QuarterRange = getQuarterRangeByYear(3, prevYear);

        if (startDate === lastYear3QuarterRange.start && endDate === lastYear3QuarterRange.end) {
            return 'prevYear3Quarter';
        }

        var lastYear2QuarterRange = getQuarterRangeByYear(2, prevYear);

        if (startDate === lastYear2QuarterRange.start && endDate === lastYear2QuarterRange.end) {
            return 'prevYear2Quarter';
        }

        var lastYear1QuarterRange = getQuarterRangeByYear(1, prevYear);

        if (startDate === lastYear1QuarterRange.start && endDate === lastYear1QuarterRange.end) {
            return 'prevYear1Quarter';
        }

        return 'custom';
    }

    var l_prevYear = getNewDate().getFullYear() - 1;

    var l_ranges = [{ label: 'All time', value: 'allTime' },
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 24 hours', value: 'last24Hours' },
    { label: 'Last 7 days', value: 'last7Days' },
    { label: 'Last 30 days', value: 'last30Days' },
    { label: 'Last 90 days', value: 'last90Days' },
    { label: 'Last month', value: 'lastMonth' },
    { label: 'Last year', value: 'lastYear' },
    { label: 'Week to date', value: 'weekToDate' },
    { label: 'Month to date', value: 'monthToDate' },
    { label: 'Quarter to date', value: 'quarterToDate' },
    { label: 'Year to date', value: 'yearToDate' },
    { label: `4th Quarter (${l_prevYear})`, value: 'prevYear4Quarter' },
    { label: `3rd Quarter (${l_prevYear})`, value: 'prevYear3Quarter' },
    { label: `2nd Quarter(${l_prevYear})`, value: 'prevYear2Quarter' },
    { label: `1st Quarter (${l_prevYear})`, value: 'prevYear1Quarter' }
    ];

    var l_range, l_startDate, l_endDate, l_title, l_startDateJs, l_endDateJs;
    var item = l_ranges.filter((p) => p.value === props.startDate)[0];

    if (typeof (item) != "undefined" && item !== null) {
        l_range = props.startDate;
        var dates = getDatesByRange(l_range);
        l_startDate = formatDate(dates === null ? getNewDate() : dates.start);
        l_endDate = formatDate(dates === null ? getNewDate() : dates.end);
        l_startDateJs = getNewDate(l_startDate);
        l_endDateJs = getNewDate(l_endDate);
        l_title = dates === null ? getTitle(l_startDateJs, l_endDateJs) : item.label;
    }
    else {
        l_startDate = props.startDate;
        l_endDate = props.endDate;
        l_range = getRange(l_startDate, l_endDate);

        if (l_range === 'custom') {
            l_ranges.unshift({ label: 'Custom', value: 'custom' });
        }

        l_startDateJs = getNewDate(l_startDate);
        l_endDateJs = getNewDate(l_endDate);
        l_title = getTitle(l_startDateJs, l_endDateJs);
    }

    var monthYear = new Date(l_endDateJs.getFullYear(), l_endDateJs.getMonth() - 1, 1);

    const [active, setActive] = useState(false);
    const [modified, setModified] = useState(false);
    const [title, setTitle] = useState(l_title);
    const [startDate, setStartDate] = useState(l_startDate);
    const [endDate, setEndDate] = useState(l_endDate);
    const [month, setMonth] = useState(monthYear.getMonth());
    const [year, setYear] = useState(monthYear.getFullYear());
    const [selectedDates, setSelectedDates] = useState({ start: l_startDateJs, end: l_endDateJs });
    const [range, setRange] = useState(l_range);
    const [ranges, setRanges] = useState(l_ranges);
    const [prevStartDate, setPrevStartDate] = useState(l_startDate);
    const [prevEndDate, setPrevEndDate] = useState(l_endDate);
    const [prevMonth, setPrevMonth] = useState(monthYear.getMonth());
    const [prevYear, setPrevYear] = useState(monthYear.getFullYear());
    const [prevRange, setPrevRange] = useState(l_range);
    const [prevSelectedDates, setPrevSelectedDates] = useState({ start: l_startDateJs, end: l_endDateJs });

    const handlePopoverOpen = useCallback(
        () => setActive(true),
        [],
    );

    const handlePopoverClose = useCallback(
        () => {
            setActive(false);
            setModified(false);
            setStartDate(prevStartDate);
            setEndDate(prevEndDate);
            setSelectedDates({ start: prevSelectedDates.start, end: prevSelectedDates.end });
            setRange(prevRange);
            setMonth(prevMonth);
            setYear(prevYear);
        },
        [prevStartDate, prevEndDate, prevSelectedDates, prevRange, prevMonth, prevYear],
    );

    const handlePopoverActive = useCallback(
        () => {
            if (active) {
                handlePopoverClose();
            }
            else {
                handlePopoverOpen();
            }
        },
        // eslint-disable-next-line
        [active],
    );

    const handleValueChange = useCallback(
        (newValue) => {
            var l_startDate = formatDate(newValue.start);
            var l_endDate = formatDate(newValue.end);
            var l_range = getRange(l_startDate, l_endDate);
            var l_ranges = [...ranges];

            if (l_range === 'custom' && l_ranges.filter((p) => p.value === 'custom').length === 0) {
                l_ranges.unshift({ label: 'Custom', value: 'custom' });
            }
            else if (l_range !== 'custom' && l_ranges.filter((p) => p.value === 'custom').length > 0) {
                var item = l_ranges.filter((p) => p.value === 'custom')[0];
                l_ranges.splice(l_ranges.indexOf(item), 1);
            }

            setModified(true);
            setStartDate(l_startDate);
            setEndDate(l_endDate);
            setSelectedDates(newValue);
            setRange(l_range);
            setRanges(l_ranges);
        },
        // eslint-disable-next-line
        [startDate, endDate, ranges],
    );

    const handleValueStringChange = useCallback(
        (newValue, fieldName) => {
            var isValid = isValidDate(newValue);
            var val;

            if (isValid) {
                val = getNewDate(newValue);
                if ((fieldName === 'startDate' && val > selectedDates.end)
                    || (fieldName === 'endDate' && (val < selectedDates.start || val > getNewDate()))) {
                    isValid = false;
                }
            }

            var l_startDate = startDate;
            var l_endDate = endDate;
            var l_range = range;
            var l_selectedDates = { ...selectedDates };
            var l_modified = modified;
            var l_ranges = [...ranges];

            if (fieldName === 'startDate') {
                l_startDate = newValue;
                if (isValid) {
                    l_selectedDates.start = val;
                }
            }
            else if (fieldName === 'endDate') {
                l_endDate = newValue;
                if (isValid) {
                    l_selectedDates.end = val;
                }
            }

            if (isValid) {
                l_modified = true;
                l_range = getRange(l_startDate, l_endDate);

                if (l_range === 'custom' && l_ranges.filter((p) => p.value === 'custom').length === 0) {
                    l_ranges.unshift({ label: 'Custom', value: 'custom' });
                }
                else if (l_range !== 'custom' && l_ranges.filter((p) => p.value === 'custom').length > 0) {
                    var item = l_ranges.filter((p) => p.value === 'custom')[0];
                    l_ranges.splice(l_ranges.indexOf(item), 1);
                }
            }

            var monthYear = new Date(l_selectedDates.end.getFullYear(), l_selectedDates.end.getMonth() - 1, 1);

            setModified(l_modified);
            setStartDate(l_startDate);
            setEndDate(l_endDate);
            setSelectedDates(l_selectedDates);
            setRange(l_range);
            setRanges(l_ranges);
            setMonth(monthYear.getMonth());
            setYear(monthYear.getFullYear());
        },
        // eslint-disable-next-line
        [modified, startDate, endDate, selectedDates, range, ranges],
    );

    const handleMonthChange = useCallback(
        (l_month, l_year) => {
            setMonth(l_month);
            setYear(l_year);
        },
        [],
    );

    const handleRangeChange = useCallback(
        (newValue) => {
            var dates = getDatesByRange(newValue);

            var startDateJs = dates === null ? selectedDates.start : dates.start;
            var endDateJs = dates === null ? selectedDates.end : dates.end;

            var l_startDate = formatDate(startDateJs);
            var l_endDate = formatDate(endDateJs);
            var l_selectedDates = { start: startDateJs, end: endDateJs };
            var monthYear = new Date(endDateJs.getFullYear(), endDateJs.getMonth() - 1, 1);

            setModified(true);
            setStartDate(l_startDate);
            setEndDate(l_endDate);
            setSelectedDates(l_selectedDates);
            setRange(newValue);
            setMonth(monthYear.getMonth());
            setYear(monthYear.getFullYear());
        },
        // eslint-disable-next-line
        [selectedDates],
    );

    const handleApply = useCallback(
        () => {
            var l_title;
            if (range === 'custom') {
                l_title = getTitle(selectedDates.start, selectedDates.end);
                props.handleChange(startDate, endDate);
            }
            else {
                l_title = ranges.filter((p) => p.value === range)[0].label;
                props.handleChange(range, range);
            }

            if (typeof props.handleTitleChange === "function") {
                props.handleTitleChange(l_title);
            }

            setActive(false);
            setModified(false);
            setPrevStartDate(startDate);
            setPrevEndDate(endDate);
            setPrevSelectedDates({ start: selectedDates.start, end: selectedDates.end });
            setPrevRange(range);
            setPrevMonth(month);
            setPrevYear(year);
            setTitle(l_title);
        },
        // eslint-disable-next-line
        [selectedDates, startDate, endDate, range, ranges, month, year],
    );

    useEffect(() => {
        if (typeof props.handleTitleChange === "function") {
            props.handleTitleChange(title);
        }
        // eslint-disable-next-line
    }, []);

    useImperativeHandle(ref, () => ({
        removeSelection() {

            let l_title = 'All time';
            let l_range = 'allTime';

            let dates = getDatesByRange(l_range);

            let startDateJs = dates === null ? selectedDates.start : dates.start;
            let endDateJs = dates === null ? selectedDates.end : dates.end;

            let l_startDate = formatDate(startDateJs);
            let l_endDate = formatDate(endDateJs);
            let l_selectedDates = { start: startDateJs, end: endDateJs };
            let monthYear = new Date(endDateJs.getFullYear(), endDateJs.getMonth() - 1, 1);

            setStartDate(l_startDate);
            setEndDate(l_endDate);
            setSelectedDates(l_selectedDates);
            setRange(l_range);
            setMonth(monthYear.getMonth());
            setYear(monthYear.getFullYear());

            props.handleChange(l_range, l_range);

            if (typeof props.handleTitleChange === "function") {
                props.handleTitleChange(l_title);
            }

            setPrevStartDate(l_startDate);
            setPrevEndDate(l_endDate);
            setPrevSelectedDates({ start: l_selectedDates.start, end: l_selectedDates.end });
            setPrevRange(l_range);
            setPrevMonth(monthYear.getMonth());
            setPrevYear(monthYear.getFullYear());
            setTitle(l_title);
        }
    }));

    const activator = (
        <Button icon={<Icon source={CalendarIcon}></Icon>} onClick={handlePopoverActive}>{props.titleInPlace ? title : props.label}</Button>
    );

    return (
        <Popover
            active={active}
            activator={activator}
            onClose={handlePopoverClose}
            preferredAlignment={'left'}
            fullHeight={true}
            fluidContent={true}
        >
            <div className="date-range-dp">
                <Popover.Section>
                    <FormLayout>
                        <Select
                            label="Date range"
                            options={ranges}
                            value={range}
                            onChange={(newValue) => handleRangeChange(newValue)}
                        />
                        <FormLayout.Group>
                            <TextField
                                label="Starting"
                                fieldName="startDate"
                                value={startDate}
                                onChange={(newValue) => handleValueStringChange(newValue, 'startDate')}
                            />
                            <TextField
                                label="Ending"
                                fieldName="endDate"
                                value={endDate}
                                onChange={(newValue) => handleValueStringChange(newValue, 'endDate')}
                            />
                        </FormLayout.Group>
                        <DatePicker
                            month={month}
                            year={year}
                            onChange={(newValue) => handleValueChange(newValue)}
                            onMonthChange={(month, year) => handleMonthChange(month, year)}
                            selected={selectedDates}
                            disableDatesAfter={getNewDate()}
                            multiMonth
                            allowRange
                        />
                    </FormLayout>
                </Popover.Section>
                <Popover.Section>
                    <LegacyStack>
                        <LegacyStack.Item fill>
                            <Button onClick={handlePopoverClose}>Cancel</Button>
                        </LegacyStack.Item>
                        <LegacyStack.Item>
                            <Button onClick={handleApply} primary disabled={!modified}>Apply</Button>
                        </LegacyStack.Item>
                    </LegacyStack>
                </Popover.Section>
            </div>
        </Popover>
    );
});